export default "__VITE_ASSET__Blg1nPqy__"